// Aktualizace aplikace (NFR-003): nová verze service workeru se použije, až uživatel není
// v rozpracovaném testu (domů, úvod, Skica). Uprostřed testu čeká.

type Update = (reload?: boolean) => Promise<void>;

let pending = false;
let update: Update | null = null;

const inTest = (path: string) => /^\/(cs|en)\/s\//.test(path);

export function setUpdate(fn: Update): void {
  update = fn;
}

export function needRefresh(): void {
  // První instalace na stránce, kterou ještě žádný worker neřídí, není aktualizace (Workbox ji
  // při přechodu mezi stránkami během instalace hlásí jako „externí“). Neobnovuje se.
  if (navigator.serviceWorker.controller === null) return;
  pending = true;
  applyUpdate(window.location.pathname);
}

/** Volá se při každé změně stránky. */
export function applyUpdate(path: string): void {
  if (!pending || update === null || inTest(path)) return;
  pending = false;
  // Workbox stránku obnoví jen u aktualizace, kterou sám našel při startu. Verzi nalezenou
  // později (kontrola za běhu) bere jako „externí“ a neobnoví, proto obnovení při převzetí řízení.
  navigator.serviceWorker.addEventListener("controllerchange", () => window.location.reload(), { once: true });
  void update(true);
}
